export default __webpack_public_path__ + "static/media/neutralFace.c59dcbd7.svg";